import DynamicImage from "../common/DynamicImage";
import SectionTitle from "../common/SectionTitle";
import { getBackgroundClass } from "../../utils/sectionHelpers";
import { HighlightText } from "../common/HighlightText";

const CoreCommitments = ({ data }) => {
    const settings = data?.Settings || {};
  
    const backgroundClass = getBackgroundClass(settings.background);
  return (
    <section className={`overview-area ptb-70 services-section ${backgroundClass}`}>
      <div className="container">

        {/* Section Title */}
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
           <SectionTitle data={data} />
          </div>
        </div>

        {/* Commitment Items */}
        {data?.commitments?.map((item, index) => {
          const isReverse = index % 2 !== 0;

          return (
            <div
              key={item.id}
              className="row justify-content-center align-items-center mt-4"
            >

              {/* Image First If Reverse */}
              {isReverse && (
                <div className="col-lg-6 order-2 order-lg-1">
                  <div className="overview-image text-center">
                    <div className="image">
                     <DynamicImage image={item.image} />
                    </div>
                  </div>
                </div>
              )}

              {/* Text */}
              <div className={`col-lg-6 ${isReverse ? "order-1 order-lg-2" : ""}`}>
                <div className="overview-box">
                  <div className="overview-content">
                    <div className="content">
                      {/* <h2>{item.title}</h2> */}
                      <h2><HighlightText content={item.title} /></h2>

                      {item?.description?.map((block, i) => {
                        if (block.type === "list") {
                          return (
                            <div key={i}>
                              {block.children.map((li, j) => (
                                <div key={j} className="features-text">
                                  <h4>
                                    <i className="flaticon-tick"></i>{" "}
                                    {li.children.map(c => c.text).join("")}
                                  </h4>
                                </div>
                              ))}
                            </div>
                          );
                        }

                        return null;
                      })}
                    </div>
                  </div>
                </div>
              </div>

              {/* Image Normal */}
              {!isReverse && (
                <div className="col-lg-6">
                  <div className="overview-image text-center">
                    <div className="image">
                     <DynamicImage image={item.image} />
                    </div>
                  </div>
                </div>
              )}

            </div>
          );
        })}

      </div>
    </section>
  );
};

export default CoreCommitments;
